import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function CheckoutCancel() {
  const { t } = useTranslation();
  return (
    <motion.div
      className="max-w-md mx-auto px-6 py-20 text-center"
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
    >
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted/10 border border-border mb-6">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-muted">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>
      <h1 className="font-display text-3xl font-bold mb-3">{t('checkout.cancelled')}</h1>
      <p className="text-muted text-sm mb-8">{t('checkout.cancelledDesc')}</p>
      <Link to="/pricing" className="inline-block px-6 py-3 rounded bg-primary hover:bg-primary-hover text-white font-medium transition-colors">
        {t('checkout.backToPricing')}
      </Link>
    </motion.div>
  );
}
